import { configureStore, createSlice, current } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage'; // localStorage
import { persistReducer, persistStore } from 'redux-persist';

// Initial state
const initialState = {
  stepOneformData: {
    TYPE: "shopify",
    SHOPIFY_SHOP: "",
    SHOPIFY_ACCESS_TOKEN: "",
    SHOPIFY_API_VERSION: "2025-01",
    FROM_DATE: null,
    END_DATE: null,
    SHOPIFY_NO_OF_ORDERS: 100
  },
  algoFormData: {
    ALGORITHM: "apriori",
    MIN_SUPPORT: 0.01,
    ANALYSIS_SCOPE: {
      isPairs: true,
      isTriples: false,
      isQuadruples: false,
      isAll: false
    },
    isExcludeSingleOrder: false
  },
  finalResultData: [],
  headerTitle: "Fashion Boutique Store",
  isAuthenticated: false,
  userInfo: {},
  storeList: [],
  orderDetailsHistory: [],
  activeStoreData: [],
  antecedentInfo: [],
  analysisResult: [],
  currentAnalysisData: [],
  // product bundles
  totalBundles: 0,
  avgItemPerBundle: 0,
  avgConversionRate: 0,
  searchQueryForItemsets: '',
  sortBy: '',
  isFavoriteSku: false,
  selectedItemSetForProductPage: 1,
  isProductPage: false,
  selectedSkuReport: {}
};

// Slice
const analysisDataSlice = createSlice({
  name: 'analysisData',
  initialState,
  reducers: {
    setSelectedSkuReport: (state, action) => {
      state.selectedSkuReport = action.payload;
    },
    setIsProductPage: (state, action) => {
      state.isProductPage = action.payload;
    },
    setSelectedItemSetForProductPage: (state, action) => {
      state.selectedItemSetForProductPage = action.payload;
    },
    setCurrentAnalysisData: (state, action) => {
      state.currentAnalysisData = action.payload;
    },
    setAnalysisResult: (state, action) => {
      state.analysisResult = action.payload;
    },
    setAntecedentInfo: (state, action) => {
      state.antecedentInfo = action.payload;
    },
    setStepOneformData: (state, action) => {
      state.stepOneformData = action.payload;
    },
    setAlgoFormData: (state, action) => {
      state.algoFormData = action.payload;
    },
    setFinalResultData: (state, action) => {
      state.finalResultData = action.payload;
    },
    setHeaderTitle: (state, action) => {
      state.headerTitle = action.payload;
    },
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setStoreList: (state, action) => {
      state.storeList = action.payload;
    },
    setOrderDetailsHistory: (state, action) => {
      state.orderDetailsHistory = action.payload;
    },
    setActiveStoreData: (state, action) => {
      state.activeStoreData = action.payload;
    },
    // product bundles
    setTotalBundles: (state, action) => {
      state.totalBundles = action.payload;
    },
    setAvgItemPerBundle: (state, action) => {
      state.avgItemPerBundle = action.payload;
    },
    setAvgConversionRate: (state, action) => {
      state.avgConversionRate = action.payload;
    },
    setSearchQueryForItemsets: (state, action) => {
      state.searchQueryForItemsets = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setIsFavoriteSku: (state, action) => {
      state.isFavoriteSku = action.payload;
    },
    
    resetAnalysisState: () => initialState
  }

  
});

export const {
  setCurrentAnalysisData,
  setAnalysisResult,
  setAntecedentInfo,
  setStepOneformData,
  setAlgoFormData,
  setFinalResultData,
  setHeaderTitle,
  setIsAuthenticated,
  setUserInfo,
  setStoreList,
  setOrderDetailsHistory,
  setActiveStoreData,
  resetAnalysisState,
  // product bundles
  setTotalBundles,
  setAvgItemPerBundle,
  setAvgConversionRate,
  setSearchQueryForItemsets,
  setSortBy,
  setIsFavoriteSku,
  setSelectedItemSetForProductPage,
  setIsProductPage,
  setSelectedSkuReport
  
} = analysisDataSlice.actions;

// Redux Persist config for analysisData slice
const analysisPersistConfig = {
  key: 'analysisData',
  storage,
  whitelist: ['activeStoreData'] // ✅ Only persist this field
};

// Persisted reducer
const persistedAnalysisReducer = persistReducer(analysisPersistConfig, analysisDataSlice.reducer);

// Configure store
const store = configureStore({
  reducer: {
    analysisData: persistedAnalysisReducer
  }
});

// Export store and persistor
export const persistor = persistStore(store);
export default store;
